import { BettingTips } from "@api-types/bet-booster/BettingTipsType";
import TeamIcon from "@components/icons/TeamIcon";
import { formatTeamName } from "@utils/format/formatter";
import classnames from "classnames";
import { observer } from "mobx-react";
import React from "react";

export default observer(function BettingTipsTeams(props: {
	data: BettingTips;
}) {
	const competitorClasses = classnames(
		"card--qp__competitor card--bbt__competitor card--qp--nowrap__competitor card--bbt--nowrap__competitor"
	);

	const iconClasses = classnames(
		"card--qp__icon card--bbt__icon u-icon u-icon--xmed"
	);

	const teamClasses = classnames(
		"card--qp__team card--mpt__team card--qp--nowrap__team card--mpt--nowrap__team"
	);

	return (
		<div className="card--qp__event card--bbt__event">
			<div className={competitorClasses}>
				<TeamIcon
					showCountryFlag={props.data.sportData?.showCountryFlag ?? false}
					flagCode={props.data.sportData?.teamOneCountryCode}
					jerseyTypeAbrv={props.data.sportData?.teamOneJerseyTypeAbrv}
					opponentFlagCode={props.data.sportData?.teamTwoCountryCode}
					opponentJerseyTypeAbrv={props.data.sportData?.teamTwoJerseyTypeAbrv}
					className={iconClasses}
				/>
				<span className={teamClasses}>
					{formatTeamName(
						props.data.sportData?.teamOneName,
						props.data.sportData?.teamOneGender,
						props.data.sportData?.eventType
					)}
				</span>
			</div>
			<div className={competitorClasses}>
				<TeamIcon
					showCountryFlag={props.data.sportData?.showCountryFlag ?? false}
					flagCode={props.data.sportData?.teamTwoCountryCode}
					jerseyTypeAbrv={props.data.sportData?.teamTwoJerseyTypeAbrv}
					opponentFlagCode={props.data.sportData?.teamOneCountryCode}
					opponentJerseyTypeAbrv={props.data.sportData?.teamOneJerseyTypeAbrv}
					className={iconClasses}
				/>
				<span className={teamClasses}>
					{formatTeamName(
						props.data.sportData?.teamTwoName,
						props.data.sportData?.teamTwoGender,
						props.data.sportData.eventType
					)}
				</span>
			</div>
		</div>
	);
});
